import React ,{Component} from 'react'
import Car from '../../assets/images/PassengerCar.svg'
class PassengerCar extends Component{
    render(){
        const {width} =this.props
        return(
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 101 51" fill="#58595B" xml="preserve" heigth="45px" width={width}>
     <title>PassengerCar</title>
    <g id="XMLID_1626_">
        <g id="XMLID_2876_">
            <polygon id="XMLID_2808_" className="st0" points="45.8,10.6 46.2,20.1 43.1,19.9 42.9,10.6"/>
        </g>
        <g id="XMLID_2003_">
            <path id="XMLID_2812_" className="st0" d="M68.6,18.5c0,0,0.7,2.6-0.1,3.1c-0.8,0.6,0.3,0.4,1.2,0.2c0.9-0.2,1.2-0.1,1.5-0.3
                c0.2-0.2,0.5-0.4,0.6-0.7c0.1-0.3,0.4-0.4,0-0.7c-0.4-0.3-0.6-0.4-0.9-0.6c-0.3-0.2-0.6-0.5-0.8-0.5c-0.2-0.1-0.8-0.4-0.8-0.4
                C69.2,18.6,68.6,18.5,68.6,18.5z"/>
            <g id="XMLID_2872_">
                <g id="XMLID_2873_">
                    <path id="XMLID_2875_" className="st0" d="M69.3,20.2c-0.1-0.1-0.1-0.1-0.1-0.2c-0.1-0.3-0.6-1.1-1.5-1.1c-1.1,0-1.4,0.7-1.5,0.9
                        c0,0.2-0.2,1.6,0.4,1.6c0.6,0,2.5,0.1,2.8-0.3C69.7,20.8,69.6,20.5,69.3,20.2z"/>
                    <path id="XMLID_2874_" className="st0" d="M69.5,20.2c-0.1-0.1-0.1-0.1-0.1-0.2c-0.1-0.3-0.6-1.1-1.5-1.1c-1.1,0-1.4,0.7-1.5,0.9
                        c0,0.2-0.2,1.6,0.4,1.6c0.6,0,2.5,0.1,2.8-0.3C69.9,20.8,69.8,20.5,69.5,20.2z"/>
                </g>
            </g>
        </g>
        <path id="XMLID_1502_" className="st0" d="M94.9,36.9c-0.1-0.1-0.2-0.3-0.6-0.3c-0.1,0-0.1,0-0.2-0.1c-0.2-0.2-0.2-0.9-0.1-1.1
            c0.1-0.3,0.8-1.2,0.7-1.9c-0.1-0.4,0-1.2,0-2c0-0.5,0-0.9-0.1-1.2c0-0.1,0-0.2-0.1-0.2c-0.1-0.2-0.1-0.5-0.3-0.8c0,0,0-0.1,0-0.1
            c-0.3-1-0.9-2.3-1.5-3.1c-0.3-0.4-0.9-1-1.7-1.6c-0.1-0.1-0.2-0.1-0.2-0.2c-1.2-0.8-2.7-1.7-4.7-2.2c-2.9-0.7-6.1-1.4-9.1-2.3
            c-0.5-0.2-1.1-0.3-1.6-0.5c0,0-0.1,0-0.1,0c-0.3-0.1-0.7-0.3-1-0.4c0,0,0,0,0,0c0,0,0,0,0,0c-0.1,0-0.3,0.2-2.5-0.7
            c-1.2-0.5-6.8-4-9.9-5.4c-2-0.9-3.9-1.6-4.2-2.1c-0.1-0.2-0.4-0.3-0.7-0.4c-5.2-1.4-8.8-1.6-8.8-1.6C47.9,8.6,35,7.3,22.8,9
            c0,0-4.1,0.5-4.7,0.9c-0.6,0.4-0.1,0.9-0.1,0.9s0.5,0.4-0.2,1.2c-0.7,0.7-4.2,5.2-5,5.7c-0.4,0.2-0.8,0.4-1.1,0.7
            c-0.3,0.2-0.5,0.4-0.8,0.7c-0.1,0.1-0.3,0.3-0.4,0.5c-0.5,0.8-1.2,2.2-1.2,3.2c0,1.2,0.1,2.3-0.7,3.2c-0.1,0.1-0.2,0.2-0.3,0.3
            c-1,1-1.8,2.4-1.7,4.1c0.1,1.7,0.3,3.5,0.6,4.4c0.2,0.7,0.8,2.1,2.1,2.8c0.4,0.2,0.9,0.4,1.4,0.5c-0.3-4.8,3.4-9,8.2-9.1h0.3
            c3.1,0,5.9,1.6,7.5,4l0,0c0.4,0.6,0.6,1.2,0.8,1.9c0.2,1.1,0.4,2.7,0,4.9h59.9c0,0,0.6,0,1.3-0.1c1.3-0.1,3.1-0.2,3.9-0.6
            c0,0,1.3-0.4,1.9-1.1c0.1-0.1,0.1-0.2,0.2-0.2h0C95.1,37.4,95,37,94.9,36.9z M12.7,25.3c-0.2,0.4-0.6,0.9-1.4,1c-0.3,0-0.7,0-1,0
            c-0.3,0-0.6,0-0.9-0.1l-0.1,0l0.1-0.1c0.3-0.3,0.4-0.7,0.5-1.1c0.1-0.5,0.1-1,0.1-1.6c0-0.1,0-0.3,0-0.4c0-1.2,0.8-2.7,1.2-3.2l0,0
            l0,0c0,0,0.6,0.1,0.7,0.8v0c0.1,1.9,0.2,3.1,0.5,3.6c0,0.1,0.1,0.1,0.1,0.1C12.8,24.6,12.9,25,12.7,25.3z M66.3,21.5
            c-3.5-0.5-40.3-3.3-42-3.4c-1.1,0-1.1,0-1.1-0.6c-0.1-0.9,0.7-3.9,2.2-5.3c1.4-1.3,3.9-1.4,3.9-1.4h0c1.7-0.2,3.8-0.2,6.2-0.2
            c8,0,16.9,0.8,20.8,1.9c5.2,1.5,14,6.9,15.4,7.9c0,0.1-0.1,0.2-0.3,0.5c-0.5,0.5-1.4,0.8-2.9,0.8C67.9,21.7,67.1,21.6,66.3,21.5z
             M87.6,39.9H70.9c-0.1-0.6-0.1-1.2-0.2-1.7c-0.3-4.8,3.4-9,8.2-9.1c0.1,0,0.2,0,0.3,0c3.1,0,5.9,1.6,7.5,4c0,0,0,0,0,0
            c0.4,0.6,0.6,1.2,0.8,1.9C87.8,36,87.9,37.6,87.6,39.9z M93.9,32.6c-1.8-0.2-5.6-3.6-5.7-3.7c-0.4-0.4-0.6-0.7-0.5-1
            c0.1-0.3,0.6-0.5,1.5-0.5c0.1,0,0.1,0,0.2,0c1.8,0.2,3.1,0.6,4.2,1.8c0.7,0.7,0.7,2,0.7,2.8C94.4,32.2,94.2,32.6,93.9,32.6
            C94,32.6,94,32.6,93.9,32.6z"/>
        <g id="XMLID_1511_">
            <path id="XMLID_1495_" className="st0" d="M19.4,30.3c-4.3,0-7.8,3.5-7.8,7.8c0,4.3,3.5,7.8,7.8,7.8c4.3,0,7.8-3.5,7.8-7.8
                C27.1,33.7,23.7,30.3,19.4,30.3z M19.4,43.2c-2.9,0-5.2-2.3-5.2-5.2c0-2.9,2.3-5.2,5.2-5.2c2.9,0,5.2,2.3,5.2,5.2
                C24.6,40.9,22.2,43.2,19.4,43.2z"/>
            <g id="XMLID_1514_">
                <rect id="XMLID_1515_" x="18.7" y="32.8" className="st0" width="1.3" height="4.1"/>

                    <rect id="XMLID_1516_" x="16.5" y="33.7" transform="matrix(0.7072 -0.707 0.707 0.7072 -20.3025 22.604)" className="st0" width="1.3" height="4.1"/>

                    <rect id="XMLID_1517_" x="15.6" y="36" transform="matrix(6.123234e-17 -1 1 6.123234e-17 -21.8239 54.2548)" className="st0" width="1.3" height="4.1"/>

                    <rect id="XMLID_1518_" x="16.5" y="38.2" transform="matrix(-0.707 -0.7072 0.7072 -0.707 0.7797 80.8557)" className="st0" width="1.3" height="4.1"/>

                    <rect id="XMLID_1519_" x="18.7" y="39.1" transform="matrix(-1 -1.224647e-16 1.224647e-16 -1 38.7294 82.3777)" className="st0" width="1.3" height="4.1"/>

                    <rect id="XMLID_1520_" x="21" y="38.2" transform="matrix(-0.707 0.7072 -0.7072 -0.707 65.333 53.4672)" className="st0" width="1.3" height="4.1"/>

                    <rect id="XMLID_1524_" x="21.9" y="36" transform="matrix(-1.836970e-16 1 -1 -1.836970e-16 60.5532 15.5256)" className="st0" width="1.3" height="4.1"/>

                    <rect id="XMLID_1525_" x="21" y="33.7" transform="matrix(0.7072 0.707 -0.707 0.7072 31.6434 -4.7793)" className="st0" width="1.3" height="4.1"/>
            </g>
            <circle id="XMLID_1527_" className="st0" cx="19.4" cy="38" r="2.1"/>
        </g>
        <g id="XMLID_1607_">
            <path id="XMLID_1499_" className="st0" d="M79.2,30.3c-4.3,0-7.8,3.5-7.8,7.8c0,4.3,3.5,7.8,7.8,7.8c4.3,0,7.8-3.5,7.8-7.8
                C87,33.7,83.5,30.3,79.2,30.3z M79.2,43.2c-2.9,0-5.2-2.3-5.2-5.2c0-2.9,2.3-5.2,5.2-5.2c2.9,0,5.2,2.3,5.2,5.2
                C84.5,40.9,82.1,43.2,79.2,43.2z"/>
            <g id="XMLID_1611_">
                <rect id="XMLID_1622_" x="78.6" y="32.8" className="st0" width="1.3" height="4.1"/>

                    <rect id="XMLID_1621_" x="76.4" y="33.7" transform="matrix(0.707 -0.7072 0.7072 0.707 -2.7618 64.9585)" className="st0" width="1.3" height="4.1"/>

                    <rect id="XMLID_1620_" x="75.5" y="36" transform="matrix(6.123234e-17 -1 1 6.123234e-17 38.0585 114.1373)" className="st0" width="1.3" height="4.1"/>

                    <rect id="XMLID_1619_" x="76.4" y="38.2" transform="matrix(-0.7069 -0.7073 0.7073 -0.7069 102.9849 123.208)" className="st0" width="1.3" height="4.1"/>

                    <rect id="XMLID_1618_" x="78.6" y="39.1" transform="matrix(-1 -1.224647e-16 1.224647e-16 -1 158.4941 82.3777)" className="st0" width="1.3" height="4.1"/>

                    <rect id="XMLID_1617_" x="80.8" y="38.2" transform="matrix(-0.7069 0.7073 -0.7073 -0.7069 167.549 11.1031)" className="st0" width="1.3" height="4.1"/>

                    <rect id="XMLID_1616_" x="81.8" y="36" transform="matrix(-1.836970e-16 1 -1 -1.836970e-16 120.4358 -44.357)" className="st0" width="1.3" height="4.1"/>

                    <rect id="XMLID_1613_" x="80.8" y="33.7" transform="matrix(0.707 0.7072 -0.7072 0.707 49.1946 -47.1247)" className="st0" width="1.3" height="4.1"/>
            </g>
            <circle id="XMLID_1610_" className="st0" cx="79.2" cy="38" r="2.1"/>
        </g>
    </g>
</svg>

    )
    }
}
export default  PassengerCar;



// WEBPACK FOOTER //
// ./src/components/Svgs/PassengerCar.js